import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import api from '../services/api';

const TopBarContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.green[800]};
  color: white;
  padding: 8px 0;
  font-size: 0.9rem;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const ContentWrapper = styled.div`
  max-width: ${({ theme }) => theme.container};
  margin: 0 auto;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const InfoGroup = styled.div`
  display: flex;
  gap: 24px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  svg {
    color: ${({ theme }) => theme.colors.orange[400]};
    font-size: 0.9em;
  }
  
  a {
    color: white;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const TopBar = () => {
  const [info, setInfo] = useState({ email: '', phone: '', address: '' });

  useEffect(() => {
    api.contact.getPage()
      .then(data => {
        if (data) {
          setInfo({
            email: data.email || 'info@foodauthority.gov.lr',
            phone: data.phone || '+231 77 000 000',
            address: data.address || 'Monrovia, Liberia'
          });
        }
      })
      .catch(() => {
        // Fallback to defaults on error
        setInfo({
          email: 'info@foodauthority.gov.lr',
          phone: '+231 77 000 000',
          address: 'Monrovia, Liberia'
        });
      });
  }, []);

  return (
    <TopBarContainer>
      <ContentWrapper>
        <InfoGroup>
          <InfoItem>
            <FaEnvelope />
            <a href={`mailto:${info.email}`}>{info.email}</a>
          </InfoItem>
          <InfoItem>
            <FaPhoneAlt />
            <a href={`tel:${info.phone}`}>{info.phone}</a>
          </InfoItem>
        </InfoGroup>
        <InfoGroup>
          <InfoItem>
            <FaMapMarkerAlt />
            <span>{info.address}</span>
          </InfoItem>
        </InfoGroup>
      </ContentWrapper>
    </TopBarContainer>
  );
};

export default TopBar;
